import { Link } from "@tanstack/react-router";
import { toAppPath } from "#/lib/router-links";

type Props = {
  first: {
    href: string;
    textOne: string;
    textTwo: string;
  };
  second: {
    textOne: string;
    textTwo: string;
  };
};

export default function Breadcrumbs({ first, second }: Props) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="mx-auto max-w-screen-xl text-sm md:text-sm" // slightly larger text size for mobile
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      <ol className="flex list-none p-3 text-xs text-gray-400 md:p-4 md:text-sm">
        <li
          className="flex shrink items-center" // vertically center text and separator
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <Link
            {...toAppPath(first.href)}
            className="flex shrink hover:text-sky-500"
            itemProp="item"
          >
            <span itemProp="name">
              <span>{first.textOne}</span>{" "}
              <span className="whitespace-nowrap">{first.textTwo}</span>
            </span>
          </Link>
          <meta itemProp="position" content="1" />
          <span className="mx-2 text-gray-400 md:mx-2">/</span>{" "}
        </li>
        <li
          className="flex shrink items-center"
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <span itemProp="name" className="">
            <span>{second.textOne}</span>{" "}
            <span className="whitespace-nowrap">{second.textTwo}</span>
          </span>
          <meta itemProp="position" content="2" />
        </li>
      </ol>
    </nav>
  );
}
